const EventEmitter = require('events')
const { io } = require('socket.io-client')

class WebsocketListener extends EventEmitter {
  constructor(url, apiKey, subscriptions) {
    super()
    this.socket = io(url, {
      auth: {
        token: apiKey
      }
    })
    this.socket.on('connect_error', err => {
      this.emit('error', err)
    })

    this.socket.on('data', data => {
      this.emit('data', data)
    })

    this.socket.emit('subscribe', subscriptions)
  }
}

module.exports = WebsocketListener
